import { BulbOutlined, EditOutlined, EyeInvisibleOutlined, EyeTwoTone, KeyOutlined, MoreOutlined, PlusOutlined, UserDeleteOutlined, VerticalAlignBottomOutlined, VerticalAlignTopOutlined } from "@ant-design/icons";
import { Button, Card, Col, Divider, Dropdown, Input, Row, Space, Statistic, Switch, Table, Tag, Typography, Modal as modalant } from "antd";
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Loading } from "../../components/Loading";
import { Modal } from "../../components/Modal";
import { SelectSearch } from '../../components/SelectSearch';
import { error_message, success_message } from "../../components/Toastr";
import { TreeSelectLocationUser } from "../../components/TreeSelectLocation";
import { ACTION, FEATURE } from "../../config/roles";
import { useAuth } from "../../hooks/auth";
import Api, { exceptionNotificationAPI } from "../../services/api";
import { getTopicAsAntDTree } from "../../utils";
import FormUser from './form';
import { FormImportUser } from './formImportUser';
import { parseToLanguagesList, parseToRolesList, parseUserListToTable } from "./helper";
import { Container, ContentPanelIndex } from './styles';

const { Title } = Typography;
const { Search } = Input;
const { confirm } = modalant;

const UserIndex = () => {
    const { t, i18n } = useTranslation();
    const { can, user } = useAuth();
    //Variáveis aba Usuários
    const [sortedInfoTable, setSortedInfoTable] = useState({
        order: "",
        columnKey: ""
    });
    const [listUserdata, setListUserdata] = useState();
    const [filterRequest, setFilterRequest] = useState({
        locationId: "",
        searchText: "",
        orderField: "name",
        ascendingOrder: true,
        pageNumber: 1,
        pageSize: 10,
        IncludeBuilderLocation: true,
        locationIncludeChildren: false
    });
    const [paginationConfig, setPaginationConfig] = useState({
        current: 1,
        total: 0,
        showSizeChanger: false,
    });

    //Variáveis gerais das duas telas
    const [formClicked, setUserItemClicked] = useState({});
    const [loadingIconUserFilter, setLoadingIconUserFilter] = useState(false);
    const [rolesList, setRolesList] = useState();
    const [languagesList, setLanguagesList] = useState();
    const [usersList, setUsersList] = useState();
    const [showModalCard, setShowModalCard] = useState(false);
    const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
    const [userSelected, setUserSelected] = useState({});
    const [loadingList, setLoadingList] = useState(true);
    const [topics, setTopics] = useState();
    const [tenantIsSSOEnabled, setTenantIsSSOEnabled] = useState();
    const [actives, setActives] = useState(0);
    const [inactives, setInactives] = useState(0);
    const [autoGeneratedPassword, setAutoGeneratedPassword] = useState(null);
    const [showModalDelegateTasks, setShowModalDelegateTasks] = useState(false);
    const [usersDropdownOptions, setUsersDropdownOptions] = useState([]);
    const [usersDropdownLoading, setUsersDropdownLoading] = useState(false);
    const [usersDropdownOptionsConfig, setUsersDropdownOptionsConfig] =
        useState({
            locationId: '',
            topicId: '',
            searchText: '',
            status: '',
            orderField: 'Name',
            ascendingOrder: undefined,
            pageNumber: 0,
            pageSize: 0,
            locationDirectParents: true,
            editAssignedTo: true,
            includeProfiles: false,
        });

    // FormImportUser
    const [showModalFormImport, setShowModalFormImport] = useState(false);
    const [userDelegatedTasks, setUserDelegatedTasks] = useState(null);

    useEffect(() => {
        async function load() {
            moment.locale('en');
            getRolesData();
            getLanguagesData();
            setTopics(getTopicAsAntDTree());
            getTenantSSOInformation();
        }
        load();
    }, []);

    useEffect(() => {
        getUserListData();
    }, [filterRequest]);

    //GETS
    const getUserListData = useCallback(() => {
        setLoadingList(true);
        Api.post("/User/getAll", filterRequest)
            .then((response) => {
                if (response.data) {
                    let formlist = parseUserListToTable(response.data);
                    setListUserdata(formlist);

                    let tempPaginationConfig = {
                        ...paginationConfig,
                        current: filterRequest.pageNumber,
                        total: response.data.response.rowCount
                    }

                    setActives(response.data.response.totalActive);
                    setInactives(response.data.response.totalInactive);
                    setPaginationConfig(tempPaginationConfig);
                    setLoadingIconUserFilter(false);
                    setLoadingList(false);
                }
            }).catch((error) => {
                exceptionNotificationAPI(error);
            });
    });

    function getRolesData() {
        Api.get(`/Role/getRolesForUser?userId=${user.id}`)
            .then((response) => {
                if (response.data) {
                    let rolesListResponse = parseToRolesList(response.data);
                    setRolesList(rolesListResponse);
                }
            }).catch((error) => {
                error_message("Error while loading roles dropdown!");
            });
    }

    function getLanguagesData() {
        Api.get("/Language/getAll")
            .then((response) => {

                if (response.data) {
                    let lanaguagesListResponse = parseToLanguagesList(response.data);
                    setLanguagesList(lanaguagesListResponse);
                }
            }).catch((error) => {
                error_message("Error while loading language dropdown!");
            });
    }

    function getTenantSSOInformation() {
        Api.post("/getTenantSSOInformation", {})
            .then((response) => {
                if (response.data && response.data.response) {
                    if (response.data.response.isSSOEnabled != null)
                        setTenantIsSSOEnabled(response.data.response.isSSOEnabled);
                }
            }).catch((error) => {
                error_message("Error while loading tenant SSO information!");
            })
    }

    const hasUppercase = (password) => /[A-Z]/.test(password);

    const setAutoPassword = () => {
        let username = Math.random().toString(36).slice(-6) + Math.floor(Math.random() * 10) + "@" + Math.random().toString(36)
            .toUpperCase().slice(10);

        if (username && hasUppercase(username)) {
            setAutoGeneratedPassword(username);
        } else {
            setAutoPassword();
        }
    }

    async function updateUserDropdownOptions(locationId = '') {
        setUsersDropdownOptions([]);
        setUsersDropdownLoading(true);
        const r = await Api.post('/User/getUsersSchedule', {
            locationId,
            topicId: usersDropdownOptionsConfig.topicId,
            searchText: usersDropdownOptionsConfig.searchText,
            locationDirectParents: usersDropdownOptionsConfig.locationDirectParents,
            editAssignedTo: usersDropdownOptionsConfig.editAssignedTo,
            includeProfiles: usersDropdownOptionsConfig.includeProfiles
        });

        const userOptions = r.data.response.map((i) => {
            return {
                label: i.name,
                value: i.id,
                locationId: i.locationId,
                companyLocationId: i.companyLocationId,
            };
        });
        setUsersDropdownOptions(userOptions);
        setUsersDropdownLoading(false);
        return userOptions;
    }

    const handleReactivateUser = (formSelected) => {
        setUserDelegatedTasks(null);
        var config = {
            title: t('User.Reactivated'),
            content: "Username: " + formSelected.userName,
            okText: t('BtnYes'),
            onOk() {
                Api.post(`/User/reactivate?userId=${formSelected.id}`)
                    .then((response) => {
                        setLoadingList(true);
                        success_message(`User:${formSelected.userName} reactivated successfully!`);
                        getUserListData();
                    }).catch((error) => {
                        exceptionNotificationAPI(error);
                    });
            },
        }

        return confirm(config);
    }

    const handleDelegateTasksSubmit = async () => {
        let objToSend = {
            newUserId: userDelegatedTasks,
            oldUserId: userSelected.key
        };

        setShowModalDelegateTasks(false);
        setLoadingList(true);

        Api.post("/FormTask/delegateTasks", objToSend)
            .then((response) => {
                Api.post(`/User/deactivate?userId=${userSelected.key}`)
                    .then((response2) => {
                        success_message(`User deactivated successfully!`);
                        getUserListData();
                    }).catch((error) => {
                        exceptionNotificationAPI(error);
                    });
            }).catch((error) => {
                exceptionNotificationAPI(error);
            })
    }

    const handleDeactivateUser = async (formSelected) => {
        setUserSelected(formSelected);
        const pending = formSelected.pendingTasks;

        if (pending && (
            pending.totalTasks > 0 ||
            pending.totalFormTasks > 0 ||
            pending.totalDocumentTasks > 0 ||
            pending.totalCreatedForms > 0 ||
            pending.totalCreatedDocuments > 0
        )) {
            await updateUserDropdownOptions();
            setShowModalDelegateTasks(true);
        }

        else {
            var config = {
                title: t('Prompt.DeactiveUser') + (formSelected.docsApprover > 0 ? " This user have " + formSelected.docsApprover + " documents linked to him as an approver, when inactivating the user, it may be necessary to make adjustments to them." : ""),
                content: "Username: " + formSelected.userName,
                okText: t('BtnYes'),
                onOk() {
                    Api.post(`/User/deactivate?userId=${formSelected.id}`)
                        .then((response) => {
                            setLoadingList(true);
                            success_message(`User:${formSelected.userName} deactivated successfully!`);
                            getUserListData();
                        }).catch((error) => {
                            exceptionNotificationAPI(error);
                        });
                },
            }
            return confirm(config);
        }
    }

    const handleSearchUserFilter = (value) => {
        value ? setLoadingIconUserFilter(true) : setLoadingIconUserFilter(false);

        let tempFilterRequest = {
            ...filterRequest,
            pageNumber: 1,
            searchText: value
        };

        setFilterRequest(tempFilterRequest);
    }

    const handleSearchLocation = (value) => {
        let tempFilterRequest = {
            ...filterRequest,
            pageNumber: 1,
            locationId: value
        };

        setFilterRequest(tempFilterRequest);
    }

    const handleAnswersSearchLocation2 = value => {
        let tempFilterRequest = {
            ...filterRequest,
            pageNumber: 1,
            locationIncludeChildren: value,
        };

        setFilterRequest(tempFilterRequest);
    };

    const handleOnChangeTable = (pagination, filters, sorter, extra) => {
        let tempFilterRequest = {
            ...filterRequest,
            pageNumber: pagination.current,
            pageSize: pagination.pageSize
        };

        let tempSortedInfoTable = {
            ...sortedInfoTable
        };

        if (sorter) {
            if (sorter.order == undefined) { //Se a ordenação foi cancelada ordena pela coluna Criado Em DESC
                tempFilterRequest = {
                    ...tempFilterRequest,
                    ascendingOrder: false,
                    orderField: "name"
                };

                tempSortedInfoTable = {
                    ...sortedInfoTable,
                    columnKey: "",
                    order: ""
                };
            } else {
                if (sorter.column != undefined) { //Verifica se alguma columa foi clicada
                    let orderFieldName = "";

                    if (sorter.columnKey == "name")
                        orderFieldName = "name";
                    else if (sorter.columnKey == "userName")
                        orderFieldName = "userName";
                    else if (sorter.columnKey == "isActive")
                        orderFieldName = "isActive";

                    tempFilterRequest = {
                        ...tempFilterRequest,
                        ascendingOrder: sorter.order == "ascend" ? true : false,
                        orderField: orderFieldName
                    };

                    tempSortedInfoTable = {
                        ...sortedInfoTable,
                        columnKey: sorter.columnKey,
                        order: sorter.order
                    };
                }
            }
        }

        setSortedInfoTable(tempSortedInfoTable);
        setFilterRequest(tempFilterRequest);
    }

    const handleEditUserForm = (tenant) => {
        setUserSelected(tenant);
        setShowModalCard(true);
    }

    const handleViewUserForm = (tenant) => {
        setUserSelected(tenant);
        setShowModalCard(true);
    }

    const handleAddUserForm = () => {
        setUserSelected({});
        setShowModalCard(true);
    }

    const handleResetPassword = (tenant) => {
        setUserSelected(tenant);
        setAutoPassword();
        setShowResetPasswordModal(true);
    }

    const handleResetPasswordSubmit = () => {
        let postObj = {
            Id: userSelected.key,
            NewPassword: autoGeneratedPassword
        }

        Api.post(`/User/generateSingleUsePassword`, postObj).then((response) => {
            success_message(t("User.ResetPasswordSuccessMessage"));
            getUserListData();
            setShowResetPasswordModal(false);
            setAutoGeneratedPassword(null);
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const renderLocationDropdown = () => {
        return <TreeSelectLocationUser includeDirectParents={false} value={filterRequest?.locationId} placeholder="Local" className='space-search pl-15' onChange={handleSearchLocation} />
    }

    const renderSearchFields = (key) => {
        return (
            <div key={key}>
                <Search
                    placeholder={t('Filter.Search.NameOrUserName')}
                    allowClear
                    loading={loadingIconUserFilter}
                    onSearch={handleSearchUserFilter}
                    className='space-search'
                />
                {renderLocationDropdown()}
                {filterRequest.locationId != undefined && filterRequest.locationId != "" && <><Switch style={{ marginLeft: 10 }} checked={filterRequest.locationIncludeChildren} onChange={handleAnswersSearchLocation2} /> {t('History.LocationBelow')}</>}
            </div>
        );
    }

    var items = [];

    if (formClicked) {
        if (can(FEATURE.USER, [ACTION.MANAGE])) {
            items.push({
                label: <Link to="#" onClick={() => handleEditUserForm(formClicked)}>{t('BtnEdit')}</Link>,
                icon: <EditOutlined />,
                key: 1
            });

            items.push({
                label: <Link to="#" onClick={() => handleDeactivateUser(formClicked)}>{t('BtnDeactive')}</Link>,
                icon: <UserDeleteOutlined />,
                key: 2
            });
        }
        if (can(FEATURE.USER, [ACTION.RESETPASSWORD]))
            items.push({
                label: <Link to="#" onClick={() => handleResetPassword(formClicked)}>{t('Login.ResetPassword')}</Link>,
                icon: <KeyOutlined />,
                key: 3
            });

        if (can(FEATURE.USER, [ACTION.MANAGE]))
            items.push({
                label: <Link to="#" onClick={() => handleViewUserForm(formClicked)}>{t('User.View')}</Link>,
                icon: <EditOutlined />,
                key: 4
            });
    }

    const formColumns = [
        {
            title: t('Name'),
            dataIndex: "name",
            width: '25%',
            key: "name",
            filterMultiple: false,
            sorter: {
                multiple: 2
            },
            sortOrder: sortedInfoTable.columnKey === 'name' && sortedInfoTable.order,
            ellipsis: true,
        },
        {
            title: t('User.UserName'),
            dataIndex: "userName",
            width: '40%',
            key: "userName",
            filterMultiple: false,
            sorter: {
                multiple: 2
            },
            sortOrder: sortedInfoTable.columnKey === 'userName' && sortedInfoTable.order,
            ellipsis: true,
        },
        {
            title: t("Administration.Profiles"),
            dataIndex: "profiles",
            key: "profiles",
            width: '20%',
            filterMultiple: false,
            ellipsis: true,
            render: (profiles) => {
                return profiles?.map(x => {
                    return x.role?.name;
                }).join(", ");
            }
        },
        {
            title: t("User.LastLogin"),
            dataIndex: "lastLogin",
            key: "lastLogin",
            width: '10%',
            filterMultiple: false,
            ellipsis: true,
            render: (lastLogin) => {
                var a = moment(lastLogin).utc();
                var b = moment().utc();
                if (a.year() <= 1000) {
                    return t("User.NotLogged")
                } else {
                    return b.diff(a, 'days') + " " + t("User.Days")
                }
            }
        },
        {
            title: t('Status'),
            dataIndex: "isActive",
            key: "isActive",
            width: '10%',
            render: (status, record) => {

                let color = "rgb(199 200 202)"; //inative
                let title = t('Inactive');
                if (status) {
                    color = 'rgb(103 209 129)'; //active
                    title = t('Active');
                }

                if (record.isDeleted) {
                    color = 'rgb(205, 32, 31)'; //deleted
                    title = t('Deleted');
                }

                return (
                    <Tag color={color} key={status} className='tag-columns'>
                        {title}
                    </Tag>
                );
            },
            sorter: {
                multiple: 2
            },
            sorter: {
                multiple: 2
            },
            sortOrder: sortedInfoTable.columnKey === 'isActive' && sortedInfoTable.order,
            ellipsis: true,
        },
        {
            title: "",
            key: "action",
            width: '5%',
            render: (form) => {
                return (
                    <div style={{ float: 'right' }}>
                        {(can(FEATURE.USER, [ACTION.VIEW]) || can(FEATURE.USER, [ACTION.MANAGE])) &&
                            <>
                                {!form.isActive ?
                                    <Link to="#"
                                        style={{ color: "#000" }}
                                        title={t('User.Reactivated.Title')}
                                        onClick={() => handleReactivateUser(form)}
                                    >
                                        <BulbOutlined />
                                    </Link>
                                    :
                                    <Dropdown
                                        menu={{ items }}
                                        onClick={() => setUserItemClicked(form)}
                                        placement="bottomLeft"
                                        trigger={['click']}
                                    >
                                        <MoreOutlined className="more-outlined" />
                                    </Dropdown>
                                }
                            </>
                        }
                    </div>

                );
            },
        },
    ];

    function exportUsers() {
        Api.post(`/User/export`, { searchText: filterRequest.searchText, locationId: filterRequest.locationId, locationIncludeChildren: filterRequest.locationIncludeChildren })
            .then((response) => {
                var binaryString = window.atob(response.data.response);
                var bytes = new Uint8Array(binaryString.length);
                var bytesMapped = bytes.map((byte, i) => binaryString.charCodeAt(i));
                var blob = new Blob([bytesMapped], { type: "application/octet-stream" });
                var link = document.createElement('a');

                link.href = window.URL.createObjectURL(blob);
                link.download = "Flowy_User_EXPORT_.xlsx";
                link.target = "_blank";
                link.click();
            }).catch((error) => {
                exceptionNotificationAPI(error);
            });
    }

    return (
        <Container>
            <Row justify="space-between">
                <Col>
                    <Title level={4} type="secondary" className="font-face-gbold">{t('User.Title')}</Title>
                </Col>
                <Col>
                    <Space>
                        {(can(FEATURE.USER, [ACTION.VIEW]) || can(FEATURE.USER, [ACTION.MANAGE])) &&
                            <Button
                                onClick={() => exportUsers()}
                                className="btn-show-modal font-face-gbook"
                                icon={<VerticalAlignBottomOutlined />}
                            >
                                {t('User.ExportU')}
                            </Button>
                        }

                        {can(FEATURE.USER, [ACTION.MANAGE]) &&
                            <>
                                <Button
                                    onClick={() => setShowModalFormImport(true)}
                                    className="btn-show-modal font-face-gbook"
                                    icon={<VerticalAlignTopOutlined />}
                                >
                                    {t("Import Users")}
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={() => handleAddUserForm()}
                                    className="btn-show-modal font-face-gbook"
                                    icon={<PlusOutlined />}
                                >
                                    {t('User.NewU')}
                                </Button>
                            </>
                        }
                    </Space>
                </Col>
            </Row>
            {!loadingList
                ?
                <>
                    <ContentPanelIndex className="font-face-gbook">
                        <Row>
                            <Col span={24} style={{ marginTop: 12 }}>
                                {renderSearchFields("search-field-1")}
                            </Col>
                        </Row>
                        <Row gutter={8} style={{ marginTop: 10 }}>
                            <Col span={4}>
                                <Card className="card-p-10">
                                    <Row>
                                        <Col span={24}>
                                            <Statistic
                                                title={t('Menu.User') + " " + t('Active')}
                                                value={actives}
                                                valueStyle={{ color: '#000' }}
                                            />
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col span={4}>
                                <Card className="card-p-10">
                                    <Row>
                                        <Col span={24}>
                                            <Statistic
                                                title={t('Menu.User') + " " + t('Inactive')}
                                                value={inactives}
                                                valueStyle={{ color: '#000' }}
                                            />
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 10 }}>
                            <Col span={24}>
                                <Table
                                    rowKey="id"
                                    columns={formColumns}
                                    dataSource={listUserdata}
                                    onChange={handleOnChangeTable}
                                    pagination={paginationConfig}
                                    filter={null}
                                    tableLayout="auto"
                                />
                            </Col>
                        </Row>
                    </ContentPanelIndex>
                </>
                :
                <div style={{ paddingTop: 28 }}>
                    <Loading />
                </div>
            }
            <Modal
                title={userSelected.key ? t('User.EditU') : t('User.NewU')}
                className="font-face-gbold"
                open={showModalCard}
                onCancel={() => setShowModalCard(false)}
                footer={null}
                width={750}
            >
                <FormUser
                    getUserListData={getUserListData}
                    topics={topics}
                    closeModal={setShowModalCard}
                    rolesList={rolesList}
                    languagesList={languagesList}
                    usersList={usersList}
                    tenantIsSSOEnabled={tenantIsSSOEnabled}
                    userFormSelected={userSelected}
                    readOnly={(!can(FEATURE.USER, [ACTION.MANAGE]))}
                />
            </Modal>
            <Modal
                title={t('Login.ResetPassword')}
                className="font-face-gbold"
                open={showResetPasswordModal}
                onCancel={() => setShowResetPasswordModal(false)}
                footer={null}
            >
                <Row>
                    <Col span={24} style={{ marginTop: 12 }}>
                        {t("User.ResetPasswordLabel")}
                    </Col>
                </Row>
                <Row gutter={8} style={{ marginTop: 10 }}>
                    <Col>
                        <Typography.Link onClick={setAutoPassword}>{t("User.BtnGeneratePassword")}</Typography.Link>
                        <Input.Password
                            size="medium"
                            type="password"
                            autoComplete="new-password"
                            value={autoGeneratedPassword}
                            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                        />
                    </Col>
                </Row>
                <Divider />
                <Row gutter={16}>
                    <Col span={24} style={{ textAlign: 'right' }}>
                        <Button key="back" onClick={() => setShowResetPasswordModal(false)}>{t('BtnCancel')}</Button>
                        <Button key="primary" onClick={() => handleResetPasswordSubmit()} htmlType="submit" type="primary" style={{ marginLeft: 8 }}>{t('BtnSave')}</Button>
                    </Col>
                </Row>
            </Modal>
            <Modal
                title={t("Import Users")}
                className="font-face-gbold"
                open={showModalFormImport}
                onCancel={() => setShowModalFormImport(false)}
                width={520}
                okButtonProps={{ style: { display: "none" } }}
            >
                <FormImportUser />
            </Modal>
            <Modal
                title={userSelected.key ? t('User.EditU') : t('User.NewU')}
                className="font-face-gbold"
                open={showModalCard}
                onCancel={() => setShowModalCard(false)}
                footer={null}
                width={750}
            >
                <FormUser
                    getUserListData={getUserListData}
                    topics={topics}
                    closeModal={setShowModalCard}
                    rolesList={rolesList}
                    languagesList={languagesList}
                    usersList={usersList}
                    tenantIsSSOEnabled={tenantIsSSOEnabled}
                    userFormSelected={userSelected}
                    readOnly={(!can(FEATURE.USER, [ACTION.MANAGE]))}
                />
            </Modal>
            <Modal
                title={t("User.RedirectTasks")}
                className="font-face-gbold"
                open={showModalDelegateTasks}
                onCancel={() => setShowModalDelegateTasks(false)}
                footer={null}
            >
                <Row style={{ marginBottom: 20 }}>
                    <Col>
                        {t("User.RedirectTasks.Message")}
                    </Col>
                </Row>
                {userSelected.pendingTasks && (
                    <>
                        <div>
                            <label>{t('Total')}: {userSelected.pendingTasks.total}</label>
                        </div>
                        {userSelected.pendingTasks.combinedTasksByStatus &&
                            Object.entries(userSelected.pendingTasks.combinedTasksByStatus).map(([status, count]) => (
                                <div key={status}>
                                    <label>{t(status)}: {count}</label>
                                </div>
                            ))
                        }
                    </>
                )}
                <Divider />
                <Row gutter={8} style={{ marginTop: 10, marginBottom: 5 }}>
                    <Col span={24}>
                        <strong>{t("Task.DelegateTo")}</strong>
                    </Col>
                </Row>
                <Row style={{ marginBottom: 20 }}>
                    <Col span={24}>
                        <SelectSearch
                            placeholder={t(
                                'Schedule.Modal.AssignedTo'
                            )}
                            optionsData={usersDropdownOptions}
                            loading={usersDropdownLoading}
                            onChange={(value) =>
                                setUserDelegatedTasks(value)
                            }
                            style={{ width: 100 + "%" }}
                        />
                    </Col>
                </Row>

                <Divider />
                <Row gutter={16}>
                    <Col span={24} style={{ textAlign: 'right' }}>
                        <Button key="back" onClick={() => setShowModalDelegateTasks(false)}>{t('BtnCancel')}</Button>
                        <Button key="primary" onClick={() => handleDelegateTasksSubmit()} htmlType="submit" type="primary" style={{ marginLeft: 8 }}>{t('BtnSave')}</Button>
                    </Col>
                </Row>
            </Modal>
        </Container>
    );
};

export default UserIndex;